import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_PAYMENT, CREATE_PAYMENT, UPDATE_PAYMENT} from 'admin/gql/Payment.gql'
import clearCache from './clearCache'
import useDestroyable from 'admin/hooks/useDestroyable'

export default (organisationId, accountId, paymentId) => {
  const {data: {payment = {}} = {}, error: getError} = useQuery(GET_PAYMENT, {
    variables: {organisationId, paymentId},
    skip: !paymentId
  })

  const [create, {error: createError}] = useMutation(CREATE_PAYMENT, {
    variables: {organisationId, accountId},
    flash: 'Payment created',
    update: (cache, {errors}) => !errors && clearCache({statement: {accountId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_PAYMENT, {
    variables: {organisationId, accountId, paymentId},
    flash: 'Payment updated',
    update: (cache, {data: {payment}, errors}) => {
      if (!errors) {
        const toClear = payment.state === 'pending' ? {paymentsPending: null} : {payments: null}
        return clearCache({
          history: {itemType: 'Payment', itemId: paymentId},
          statement: {accountId},
          ...toClear
        })(cache)
      }
    }
  })

  const {destroy, errors: destroyError} = useDestroyable('Payment', paymentId)

  return {
    payment,
    errors: getError || createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
